import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { styles } from './styles';
import { DeletedActionsPopper } from '../deleted-actions-popper';
import { convertBytes } from 'utils/helpers';
import { getRowIcon } from 'utils/helpers/fileCabinetHelpers';
import { TProjectDeletedFile } from 'redux-store/api/file-cabinet';

interface IDeletedFileListView {
  deletedFiles: TProjectDeletedFile[];
  onDeleteFile: (fileId: number) => void;
  onViewFile: (file: TProjectDeletedFile) => void;
  onRestoreFile: (fileId: number) => void;
}

export const DeletedFileListView = ({
  deletedFiles,
  onDeleteFile,
  onViewFile,
  onRestoreFile,
}: IDeletedFileListView) => {
  if (!deletedFiles.length) return null;

  return (
    <Grid sx={{ height: '100%', width: '100%' }}>
      <Grid sx={styles.container}>
        <TableContainer sx={styles.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={styles.tableHeadItem}>Item</TableCell>
                <TableCell sx={styles.tableHeadItem}>Size</TableCell>
                <TableCell sx={styles.tableHeadItem}></TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {deletedFiles?.map((file) => {
                const Icon = getRowIcon('file', file?.mimeType);

                return (
                  <TableRow key={file.id} sx={styles.tableRow}>
                    <TableCell sx={styles.tableCell} className="first">
                      <Grid sx={styles.nameWrapper} onClick={() => onViewFile(file)}>
                        <Icon />
                        <Typography>{file.name}</Typography>
                      </Grid>
                    </TableCell>
                    <TableCell sx={styles.tableCell}>
                      <Typography>{convertBytes(Number(file?.size), 2)}</Typography>
                    </TableCell>
                    <TableCell sx={styles.tableCell} className="actions-wrapper">
                      <DeletedActionsPopper
                        onRestoreFile={() => onRestoreFile(file.id)}
                        onDeleteFile={() => onDeleteFile(file.id)}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
